import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.891 4.861C9.637 3.801 10.818 3 12.461 3c1.28 0 2.257.337 2.985.945.716.598 1.118 1.398 1.37 2.188a.7.7 0 0 1-1.333.426c-.208-.652-.498-1.176-.934-1.54-.426-.355-1.063-.619-2.088-.619-1.124 0-1.902.523-2.424 1.266-.54.767-.795 1.764-.795 2.605 0 .623.149 1.237.326 1.963.09.37.186.767.258 1.186h4.018a.7.7 0 1 1 0 1.4h-3.91c-.004 1.584-.07 3.847-1.585 6.224.43-.111.877-.214 1.322-.288 1.284-.215 2.732-.238 4.036.442 1.292.674 2.654.423 3.888-.435a.7.7 0 0 1 .8 1.15c-1.534 1.066-3.457 1.506-5.335.526-.91-.474-1.998-.497-3.158-.303-.811.136-1.57.358-2.29.568-.331.097-.654.191-.969.273a.7.7 0 0 1-.682-1.161c2.47-2.578 2.568-5.123 2.572-6.996H6.006a.7.7 0 1 1 0-1.4h2.396a21 21 0 0 0-.21-.918c-.165-.677-.35-1.435-.35-2.231 0-1.084.32-2.372 1.05-3.41",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=CurrencyBritishPoundIcon24.js.map